import { render } from "./ClientClientesListado.vue?vue&type=template&id=08a5344e&scoped=true"
import script from "./ClientClientesListado.vue?vue&type=script&lang=js"
export * from "./ClientClientesListado.vue?vue&type=script&lang=js"

import "./ClientClientesListado.vue?vue&type=style&index=0&id=08a5344e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a5344e"]])

export default __exports__